import React from "react";

import dayjs from "dayjs";

import { colors } from "components";

import { BaseCard } from "components/BaseCard";
import { CircularButton } from "components/CircularButton";
import { AgendaOpenedIndicator } from "components/ScheduleCard/AgendaOpenedIndicator";
import { SquareCard } from "components/SquareCard";
import { TitleSubTitleLabel } from "components/TitleSubTitleLabel";

import { IProcedureScheduleCard } from "./interfaces";
import {
  ButtonContainer,
  ProcedureScheduleCardTopContainer,
  Container,
  LeftContainer,
  RightContainer,
} from "./styles";

export const ProcedureScheduleCard: React.FC<IProcedureScheduleCard> = ({
  id,
  title,
  subTitle,
  selected = false,
  agendaOpened = false,
  day,
  time,
  copyTooltip,
  disabledCopy = false,
  disabledDelete = false,
  disabledEdit = false,
  disabledRecord = false,
  disabled = false,
  hideCopyButton = false,
  onClickItem,
  onClickDelete,
  onClickCopy,
  onClickEdit,
  onClickRecord,
}) => {
  const fullDayFormat = dayjs(day).format("DD/MM/YYYY");
  const dayFormat: string =
    fullDayFormat === dayjs(new Date()).format("DD/MM/YYYY")
      ? "Hoje"
      : dayjs(day).format("DD/MM");

  const hourFormat: string = dayjs(time).format("HH:mm");
  return (
    <ProcedureScheduleCardTopContainer data-testid={id}>
      <BaseCard
        selected={selected}
        fixedBorder={true}
        onClick={onClickItem}
        disabled={disabled}
      >
        <Container>
          <LeftContainer>
            <SquareCard
              title={dayFormat}
              subTitle={hourFormat}
              width={60}
              height={52}
            />
            <TitleSubTitleLabel
              childrenTitle={title}
              childrenSubTitle={subTitle}
              marginTop="0px"
              marginBottom="0px"
              marginLeft="0px"
              marginRight="0px"
              marginBetweenTitleAndSubTitle="2px"
            />
          </LeftContainer>
          <RightContainer id="buttonsRight">
            {!hideCopyButton && (
              <ButtonContainer id="copy_button">
                <CircularButton
                  id="copy_button_circular"
                  icon="copy"
                  copyTooltip={copyTooltip}
                  onClick={onClickCopy}
                  colorIcon={colors.neutral_white}
                  border={`2px solid ${colors.primary_default}`}
                  backgroundColor={colors.primary_default}
                  disabled={disabledCopy}
                />
              </ButtonContainer>
            )}
            <ButtonContainer id="delete_button">
              <CircularButton
                id="delete_button_circular"
                icon="delete"
                onClick={onClickDelete}
                colorIcon={colors.neutral_white}
                border={`2px solid ${colors.primary_default}`}
                backgroundColor={colors.primary_default}
                disabled={disabledDelete}
              />
            </ButtonContainer>
            <ButtonContainer id="edit_button">
              <CircularButton
                id="edit_button_circular"
                icon="edit"
                onClick={onClickEdit}
                colorIcon={colors.neutral_white}
                border={`2px solid ${colors.primary_default}`}
                backgroundColor={colors.primary_default}
                disabled={disabledEdit}
              />
            </ButtonContainer>
            <ButtonContainer
              id="record_button"
              style={{ position: "relative" }}
            >
              <CircularButton
                id="record_button_circular"
                icon="record"
                onClick={onClickRecord}
                colorIcon={colors.neutral_white}
                border={`2px solid ${colors.primary_default}`}
                backgroundColor={colors.primary_default}
                disabled={disabledRecord}
                highlight
              />
              {agendaOpened && <AgendaOpenedIndicator />}
            </ButtonContainer>
          </RightContainer>
        </Container>
      </BaseCard>
    </ProcedureScheduleCardTopContainer>
  );
};
